
import $ from "jquery";
import counterUp from 'counterup2'

const callback = entries => {
    console.log('Entries: ', entries);
    entries.forEach( entry => {
        const el = entry.target;
        console.log('Element: ', el);
        if ( entry.isIntersecting && ! el.classList.contains( 'is-visible' ) ) {
            counterUp( el, {
                duration: 2000,
                delay: 16,
            } )
            el.classList.add( 'is-visible' )
        }
    } )
}

const IO = new IntersectionObserver( callback, { threshold: 1 } )

$(document).ready(function() {
    const counters = document.querySelectorAll( '.counter' );
    $(counters).each(function( index ) {
        IO.observe( $(this)[0] )
    });
});


